































































import { Component, Vue } from 'vue-property-decorator'
import Page from '@/components/Page/index.vue'
import StatusFlash from '@/components/StatusFlash/index.vue'
import FacetedSearch from '@/components/FacetedSearch/index.vue'
import EntityMetadata from '@/components/EntityMetadata/index.vue'
import Status from '@/utils/Status'
import Graph from '@/rdf/Graph'
import { DCT } from '@/rdf/namespaces'
import config from '@/config'
import api from '@/api'
import metadata from '@/utils/metadata'

const STAT_CONFIG = [
  { label: 'Catalog', icon: 'layer-group' },
  { label: 'Dataset', icon: 'table' },
  { label: 'Distribution', icon: 'file-export' },
]

@Component({
  components: {
    Page, StatusFlash, FacetedSearch, EntityMetadata,
  },
})
export default class LandingPage extends Vue {
  status: Status = new Status()

  entity: { title: string, description: string } = null

  metadata: any[] = []

  stats: { label: string, icon: string, value: number }[] = []

  get appTitle() {
    return config.appTitle()
  }

  get appSubtitle() {
    return config.appSubtitle()
  }

  created(): void {
    this.init()
  }

  async init() {
    try {
      this.status.setPending()

      const repoConfig = this.$store.getters['entities/config']('')
      const response = await repoConfig.api.get()
      const graph = new Graph(response.data, repoConfig.subject(undefined))
      this.entity = {
        title: graph.findOne(DCT('title')) as string,
        description: graph.findOne(DCT('description')) as string,
      }
      this.metadata = metadata.commonMetadata(graph)

      if (api.searchIndex.isEnabled()) {
        this.stats = await this.loadStats()
      }

      this.status.setDone()
    } catch (error) {
      this.status.setErrorFromResponse(error, 'Unable to get data.')
    }
  }

  async loadStats() {
    const response = await api.searchIndex.search('', [], ['entityType'])
    const distribution = response.facetDistribution.entityType || {}
    return STAT_CONFIG.map(({ label, icon }) => ({
      label,
      icon,
      value: distribution[label] || 0,
    }))
  }
}
